/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ExposureDefinitionDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    firmId?: string;
    predefinedId?: string;
    source?: ExposureDefinitionDto.source;
    hazardSourceDefinitionId?: number;
    exposureName?: string;
    status?: ExposureDefinitionDto.status;
    label?: string;
}

export namespace ExposureDefinitionDto {

    export enum source {
        SYSTEM = 'SYSTEM',
        USER_DEFINED = 'USER_DEFINED',
    }

    export enum status {
        DELETED = 'DELETED',
        ACTIVE = 'ACTIVE',
        NURSE_OPERATION = 'NURSE_OPERATION',
        ARCHIVED = 'ARCHIVED',
        PASSIVE = 'PASSIVE',
    }


}
